import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';

import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SendIcon from '@material-ui/icons/Send';
import CircularProgress from '@material-ui/core/CircularProgress';

import axios from 'axios';

import { sendInBlueApiKey } from 'src/api/environment';
import { sendInBlueUrl } from 'src/api/environment';

import newsletterCover from '../../assets/cover/newsletter_cover.webp';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(0),
  },
  paperTitle: {
    padding: theme.spacing(4),
    background: 'rgba(255, 255, 255, 0.9)'
  },
  section: {
    padding: '5rem 0',
    background: `url(${newsletterCover})`,
    backgroundPosition: 'right',
  },
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 400,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

const PartnerSection = () => {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(false);
  const [isRegistered, setIsRegistered] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    console.log(localStorage.getItem('isRegistered'))
    if (localStorage.getItem('isRegistered') === 'true') {
      setIsRegistered(true);
    }
  }, isRegistered)

  const registerToNewsletter = () => {
    if (localStorage.getItem('isRegistered') === 'true') {
      setIsRegistered(true);
    } else {
      setLoading(true);
      localStorage.setItem('isRegistered', 'true')
      
      axios.post(sendInBlueUrl, { email: email }, {
        headers: { 'Content-Type': 'application/json', 'api-key': sendInBlueApiKey }
      })
        .then((response) => {
          setLoading(false);
          setIsRegistered(true);
          enqueueSnackbar('Votre inscription à la newsletter à bien été reçu', { variant: 'success' });
        })
        .catch((error) => {
          enqueueSnackbar('Vous êtes déjà inscrit à la newsletter', { variant: 'info' });
          setLoading(false);
        })
    }
  }

  return (
    <>
      <Grid
        className={classes.section}
        component="section"
        container
        xs={12}
      >
        <Grid
          item
          md={7}
          sm={12}
          xs={12}
        >
          <Paper
            className={classes.paperTitle}
            component="header"
          >
            <Typography
              component="h2"
              variant="h1"
            >
              inscription à la newsletter
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              Nous respectons la nature et également votre boite mail 🌱😁🐭. <br />
              Nous nous engageons à ne jamais transmitter votre adresse email à des services tiers.
            </Typography>
            <Paper
              className={classes.root}
              component="form"
              style={{marginTop: '4rem', maxWidth: '100%'}}
            >
              {isRegistered ? 
                <InputBase
                  InputProps={{
                    readOnly: true,
                  }}
                  className={classes.input}
                  inputProps={{ 'aria-label': 'Votre adresse email' }}
                  onChange={(e) => setEmail(e.target.value)}
                  value="Vous êtes déjà inscrit à la Newsletter 😁"
                />
                :
                <InputBase
                  className={classes.input}
                  inputProps={{ 'aria-label': 'Votre adresse email' }}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Votre adresse email"
                />
              }
              <Divider
                className={classes.divider}
                orientation="vertical"
              />
              <IconButton
                aria-label="directions"
                className={classes.iconButton}
                color="primary"
                onClick={registerToNewsletter}
              >
                {loading ?
                  <CircularProgress
                    size={30}
                    style={{}}
                  />
                  :
                  <SendIcon />
                }
              </IconButton>
            </Paper>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default PartnerSection;
